export default __webpack_public_path__ + "static/media/13.b017a875.webp";